import axios from "axios";
import Instense from "./Axios-config";
import { API_ROOT } from "./Api-config";
import {
  ICustomerorder
  } from "../Contracts/ICustomerorder";
export class VendorService {


  public static GetCustomerOrder = async (): Promise<
  ICustomerorder[] | null
> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  let request = {} as any;
  request.tenantID = tenantID;

  const url = `/Customer/GetCustomerOrderList`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as ICustomerorder[];
   
    return result;
  });
};

public static GetAllVendorOrder = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
            
  request.locationId = locationId;
  // debugger;
  request.tenantid = tenantID;
  const url = `/Vendor/GetAllVendorOrder`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static GetAllVendorInbox = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  // debugger;
  request.tenantid = tenantID;
  request.type="PO";
  const url = `/Mail/GetInbox`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};
 
public static GetAllInvoiceInbox = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  // debugger;
  request.tenantid = tenantID;
  request.type="INV";
  const url = `/Mail/GetInbox`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};
 
public static GetJobOrderlistByItem = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  // debugger;
  request.tenantID = tenantID;
  const url = `/Vendor/GetJobOrderlistByItem`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static Getorderdata = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
   
  request.tenantid = tenantID;
  const url = `/Vendor/GetVendorOrderData`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static GetQuotationData = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
   
  request.tenantid = tenantID;
  const url = `/Vendor/GetVendorQuotationData`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static GetVendorData = async (request: any): Promise<any | null> => {
 
  const url = `/Vendor/GetVendorQuotationData`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static GetVendorReceivingData = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
   
  request.tenantid = tenantID;
  const url = `/Vendor/GetVendorReceivingData`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};


public static GetVendorById = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
   
  request.tenantid = tenantID;
  const url = `/Vendor/GetVendorById`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static GetVendorlist = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
   
  request.tenantid = tenantID;
  const url = `/Vendor/GetVendorlist`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static GetEmailTrack = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
   
  request.tenantid = tenantID;
  const url = `/Vendor/GetEmailTrack`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static GetJobDescription = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
   
  request.tenantid = tenantID;
  const url = `/Vendor/GetJobDescription`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static GetVendorlist2 = async (request: any): Promise<any | null> => {
  
  const url = `/Vendor/GetVendorlist`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};
public static GetVendorlistGrp = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
   
  request.tenantid = tenantID;
  const url = `/Customer/GetVendorListGrp`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};
public static GetVendorlistGrp1 = async (request: any): Promise<any | null> => {
     const url = `/Customer/GetVendorListGrp`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static GetRFQResponses = async (request: any): Promise<any | null> => {
  const url = `/Vendor/GetRFQResponses`;
return Instense.get(url, { params: request }).then((response) => {
 let result = response.data.result as any;
 return result;
});
};

public static GetCustomerAddress = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
   
  request.tenantid = tenantID;
  const url = `/Customer/GetCustomerAddress`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static GetVendorContract = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
   
  request.tenantid = tenantID;
  const url = `/Customer/GetCustomerAddress`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};
 

public static SaveVendorData = async (request: any): Promise<any> => {

  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  let userName = storage === null ? "" : (storage.userName as any);
  request.TenantID = tenantID;
  request.Tenantid = tenantID;
  request.UserName = userName;
  const url = `/Vendor/SaveVendorData `;
  return Instense.post(url, request).then((response) => {
    
      let result = response.data.result as any[];
      return result;
  });
};

public static SaveRFQResponses = async (request: any): Promise<any> => {

  
  const url = `/Vendor/SaveRFQResponses `;
  return Instense.post(url, request).then((response) => {
    
      let result = response.data.result as any[];
      return result;
  });
};


public static SaveEditRequest = async (request: any): Promise<any | null> => {
  const url = `/Vendor/SaveEditRequest`;
return Instense.get(url, { params: request }).then((response) => {
 let result = response.data.result as any;
 return result;
});
};


public static ApproveRequest = async (request: any): Promise<any | null> => {
   let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  request.tenantid = tenantID;
  const url = `/Vendor/ApproveRequest`;
return Instense.get(url, { params: request }).then((response) => {
 let result = response.data.result as any;
 return result;
});
};

public static EmailTrack = async (request: any): Promise<any> => {

  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  request.tenantid = tenantID;
  const url = `/Vendor/EmailTrack `;
  return Instense.post(url, request).then((response) => {
    
      let result = response.data.result as any[];
      return result;
  });
};


public static VendorEmailTrack = async (request: any): Promise<any | null> => {
   let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  request.tenantid = tenantID;
  const url = `/Vendor/VendorEmailTrack`;
return Instense.get(url, { params: request }).then((response) => {
 let result = response.data.result as any;
 return result;
});
};

public static SaveVendorEmail = async (request: any): Promise<any> => {

  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  request.tenantid = tenantID;
  const url = `/Vendor/SaveVendorEmail `;
  return Instense.post(url, request).then((response) => {
    
      let result = response.data.result as any[];
      return result;
  });
};

public static DownloadResponsePDFFile = async (request: any): Promise<any | null> => {

  
  const url = `/Vendor/GetRFQPDF`;
  return Instense.get(url,{params:request,  responseType: "blob", headers: {
    'Accept': '*/*',
  }, } ).then(
    (response: any) => {
      // Check if the response is successful
      if (response.status === 200) {
        // if(Isdownload==true)
        // {

          let csvURL = window.URL.createObjectURL(response.data);
          let tempLink = document.createElement("a");
          tempLink.href = csvURL;
          tempLink.setAttribute("download", request.name);
          tempLink.click();
        // }

        // else
        // {
        // const blob = new Blob([response.data], { type: 'application/pdf' });
        // // Open the PDF in a new browser tab
        // const blobUrl = URL.createObjectURL(blob);
        // window.open(blobUrl, '_blank');
        // }
      } 
    }
  );
};


public static DeleteVendorOrder = async (
  request:  any
): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : storage.tenantID as any;
  request.tenantId = tenantID;
  const url = `/Vendor/DeleteVendorOrder`;
  return Instense.delete(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static DeleteVendorQuotation = async (
  request:  any
): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : storage.tenantID as any;
  request.tenantId = tenantID;
  const url = `/Vendor/DeleteVendorQuotation`;
  return Instense.delete(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};
public static Saveorder = async (request: any): Promise<any> => {
  // debugger;
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  let userName = storage === null ? "" : (storage.userName as any);
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
  
  request.locationId = locationId;
  request.TenantID = tenantID;
  request.UserName = userName;
  const url = `/Vendor/SaveOrder `;
  return Instense.post(url, request).then((response) => {
    // debugger;
      let result = response.data.result as any[];
      return result;
  });
};

public static SaveorderFiles = async (
  request: any, files: any[]
): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : storage.tenantID as any;
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
  
  request.locationId = locationId;
  request.TenantID = tenantID;

  const url =`/Vendor/SaveOrderFiles`;
  const formData: FormData = new FormData();
  files.forEach(element => {
    formData.append('file', element);
  });

  formData.append('formField', JSON.stringify(request));
  return Instense.post(url, formData).then((response) => {
    let result = response.data.result as any;
    return result;
  });

};

public static SaveQuotationorderFiles = async (
  request: any, files: any[]
): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : storage.tenantID as any;
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
  
  request.Locationid = locationId;
  request.TenantID = tenantID;

  const url =`/Vendor/SaveQuotationOrderFiles`;
  const formData: FormData = new FormData();
  files.forEach(element => {
    formData.append('file', element);
  });

  formData.append('formField', JSON.stringify(request));
  return Instense.post(url, formData).then((response) => {
    let result = response.data.result as any;
    return result;
  });

};


public static Convertorder = async (request: any): Promise<any> => {
  // debugger;
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  let userName = storage === null ? "" : (storage.userName as any);
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
 
  request.locationId = locationId;
  request.TenantID = tenantID;
  request.UserName = userName;
  const url = `/Vendor/ConvertQuotationVendorOrder `;
  return Instense.post(url, request).then((response) => {
    // debugger;
      let result = response.data.result as any[];
      return result;
  });
};


public static UpdateConvertedResponse = async (request: any): Promise<any> => {
  
  const url = `/Vendor/UpdateConvertedResponse `;
  return Instense.post(url, request).then((response) => {
    // debugger;
      let result = response.data.result as any[];
      return result;
  });
};

public static SaveQuotation = async (request: any): Promise<any> => {
  // debugger;
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  let userName = storage === null ? "" : (storage.userName as any);
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
  
  request.locationId = locationId;
  request.TenantID = tenantID;
  request.UserName = userName;
  const url = `/Vendor/SaveQuotation `;
  return Instense.post(url, request).then((response) => {
    // debugger;
      let result = response.data.result as any[];
      return result;
  });
};

public static SaveRFQfiles = async (
  request: any, files: any[]
): Promise<any | null> => {


  const url = `/Vendor/SaveRFQFile`;
  const formData: FormData = new FormData();
  files.forEach(element => {
    formData.append('file', element);
  });

  formData.append('formField', JSON.stringify(request));
  return Instense.post(url, formData).then((response) => {
    let result = response.data.result as any;
    return result;
  });

};

public static GetRFQFile = async (request: any): Promise<any | null> => {

  const url = `/Vendor/GetRFQFile`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static DeleteRFQFile = async (request: any): Promise<any[] | null> => {
  
   const url = `/Vendor/DeleteRFQFile`;
  return Instense.post(url, request).then((response) => {
    let result = response.data.result as any;
    return result;
  });

};

public static DownloadRFQFile = async (
  request: any
): Promise<any | null> => {
  

  const url = `/Vendor/DownloadRFQFile`;
  return Instense.post(url, request, { responseType: "blob" }).then(
    (response: any) => {

      let csvURL = window.URL.createObjectURL(response.data);
      let tempLink = document.createElement("a");
      tempLink.href = csvURL;
      tempLink.setAttribute("download", request.name);
      tempLink.click();
    }
  );
};
   
public static SaveReceivingData = async (request: any): Promise<any> => {
  // debugger;
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  let userName = storage === null ? "" : (storage.userName as any);
  request.TenantID = tenantID;
  request.UserName = userName;
  const url = `/Vendor/SaveReceivingData `;
  return Instense.post(url, request).then((response) => {
    // debugger;
      let result = response.data.result as any[];
      return result;
  });
};

public static DownloadVendorOrderFile = async (
  request: any
): Promise<any | null> => {

  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  let userName = storage === null ? "" : (storage.userName as any);
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
              
  request.locationId = locationId;
  request.tenantid = tenantID;
  request.UserName = userName;
  const url = `/Vendor/GetVendorPDF`;
  return Instense.get(url,{params:request,  responseType: "blob", headers: {
    'Accept': '*/*',
  }, } ).then(
    (response: any) => {
      // Check if the response is successful
      if (response.status === 200) {
        
        const blob = new Blob([response.data], { type: 'application/pdf' });
        // Open the PDF in a new browser tab
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
      } 
    }
  );
};

public static DownloadVendorQuotationFile = async (
  request: any
): Promise<any | null> => {

  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  let userName = storage === null ? "" : (storage.userName as any);
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
              
  request.locationId = locationId;
  request.tenantid = tenantID;
  request.UserName = userName;
  const url = `/Vendor/GetVendorQuotationPDF`;
  return Instense.get(url,{params:request,  responseType: "blob", headers: {
    'Accept': '*/*',
  }, } ).then(
    (response: any) => {
      // Check if the response is successful
      if (response.status === 200) {
        
        const blob = new Blob([response.data], { type: 'application/pdf' });
        // Open the PDF in a new browser tab
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
      } 
    }
  );
};



public static SendMailToVendor = async (
  request: any,mailRequest: any,
): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  let userName = storage === null ? "" : (storage.userName as any);
  request.tenantid = tenantID;
  request.UserName = userName;
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
              
  request.locationId = locationId;
  const url = `/Vendor/GetVendorPDF`;
  return Instense.get(url,{params:request,  responseType: "blob", headers: {
    'Accept': '*/*',
  }, } ).then(
    (response: any) => {
      // Check if the response is successful
      if (response.status === 200) {
        // mailRequest.files = new File([response.data], 'attachment.pdf');  
         const vendorPDF = new File([response.data], 'PurchaseOrder.pdf');
         mailRequest.append("files", vendorPDF);
    
        let saveItems = mailRequest; //Object.assign({}, JSON.parse(JSON.stringify(item)));
        
    const url = `/Mail/SendMail`;
    return Instense.post(url,saveItems, {headers: {
      'Content-Type': 'multipart/form-data',
      'accept': '*/*',
    },}  ).then(
      (response: any) => {
        // Check if the response is successful
        if (response.status === 200) {
         
        } 
      }
    );

      } 
    }
  );
};

public static SendMailToCustomer = async (
  request: any,mailRequest: any,
): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  let userName = storage === null ? "" : (storage.userName as any);
  request.tenantid = tenantID;
  request.UserName = userName;
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
              
  request.locationId = locationId;
  const url = `/Customer/GetQuotationPDF`;
  return Instense.get(url,{params:request,  responseType: "blob", headers: {
    'Accept': '*/*',
  }, } ).then(
    (response: any) => {
      // Check if the response is successful
      if (response.status === 200) {
        // mailRequest.files = new File([response.data], 'attachment.pdf');  
         const vendorPDF = new File([response.data], 'CustomerQuotation.pdf');
         mailRequest.append("files", vendorPDF);
    
        let saveItems = mailRequest; //Object.assign({}, JSON.parse(JSON.stringify(item)));
        
    const url = `/Mail/SendMail`;
    return Instense.post(url,saveItems, {headers: {
      'Content-Type': 'multipart/form-data',
      'accept': '*/*',
    },}  ).then(
      (response: any) => {
        // Check if the response is successful
        if (response.status === 200) {
         
        } 
      }
    );

      } 
    }
  );
};


public static SendMail = async (
  mailRequest: any,
): Promise<any | null> => {
  const url = `/Mail/SendMail`;
  return Instense.post(url, mailRequest, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'accept': '*/*',
    },
  }).then((response: any) => {
    if (response.status === 200) {
      // success
      return response.data;
    }
    return null;
  }).catch((error: any) => {
    console.error("Error sending mail:", error);
    return null;
  });
};

public static SendMailVendor = async (
  mailRequest: any,
): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  mailRequest.tenantid = tenantID;
  const url = `/Mail/SendMailVendor`;
  return Instense.post(url, mailRequest, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'accept': '*/*',
    },
  }).then((response: any) => {
    if (response.status === 200) {
      // success
      return response.data;
    }
    return null;
  }).catch((error: any) => {
    console.error("Error sending mail:", error);
    return null;
  });
};

public static Savefiles = async (
  request: any, files: any[]
): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : storage.tenantID as any;
  request.tenantID = tenantID;




  const url = `/Customer/SaveFile `;
  const formData: FormData = new FormData();
  files.forEach(element => {
    formData.append('file', element);
  });

  formData.append('formField', JSON.stringify(request));
  return Instense.post(url, formData).then((response) => {
    let result = response.data.result as any;
    return result;
  });



};




public static GetUploadFileList = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
 
  request.tenantID = tenantID;
  const url = `/Customer/GetUploadFileList`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static GetUploadFileWithFileCode = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  // let userUniqueID = storage === null ? 0 : (storage.user_UniqueID as any);
  // debugger

  request.tenantID = tenantID;
  const url = `/Customer/GetUploadFileWithFileCode`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static DeleteUploadedFile = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  // let userUniqueID = storage === null ? 0 : (storage.user_UniqueID as any);
  // debugger

  request.tenantID = tenantID;
  const url = `/Customer/DeleteUploadedFile`;
  return Instense.post(url, request).then((response) => {
    let result = response.data.result as any;
    return result;
  });

};

public static GetVendorInvoiceSearch = async (request: any): Promise<
ICustomerorder[] | null
> => {
let storage = JSON.parse(localStorage.getItem("storage")!);
let tenantID = storage === null ? 0 : (storage.tenantID as any);
//let request = {} as any;
const raw = localStorage.getItem("locationId");
request.tenantid = tenantID;
const locationId = raw === null ? 0 : Number(raw) ;
  
request.locationId = locationId;

const url = `/Vendor/GetVendorInvoiceSearch`;
return Instense.get(url, { params: request }).then((response) => {
  let result = response.data.result as ICustomerorder[];
 
  return result;
});
};

public static GetVendorOrderSearch = async (request: any): Promise<
ICustomerorder[] | null
> => {
let storage = JSON.parse(localStorage.getItem("storage")!);
let tenantID = storage === null ? 0 : (storage.tenantID as any);
//let request = {} as any;
request.tenantID = tenantID;

const url = `/Job/GetVendorOrderlistSearch`;
return Instense.get(url, { params: request }).then((response) => {
  let result = response.data.result as any;
 
  return result;
});
};

public static SaveVendorGroup = async (request: any): Promise<any> => {
  // 
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  request.tenantid = tenantID;
  const url = `/Customer/SaveVendorGroup `;
  return Instense.post(url, request).then((response) => {
    // 
      let result = response.data.result as any[];
      return result;
  });
};

public static GetVendorGroups = async (request: any): Promise<
ICustomerorder[] | null
> => {
let storage = JSON.parse(localStorage.getItem("storage")!);
let tenantID = storage === null ? 0 : (storage.tenantID as any);
//let request = {} as any;
request.tenantid = tenantID;

const url = `/Customer/GetVendorGroups`;
return Instense.get(url, { params: request }).then((response) => {
  let result = response.data.result as any;
 
  return result;
});
};

public static SaveVendorGroupDetails = async (request: any): Promise<any> => {
  // 
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  request.tenantid = tenantID;
  const url = `/Customer/SaveVendorGroupDetails `;
  return Instense.post(url, request).then((response) => {
    // 
      let result = response.data.result as any[];
      return result;
  });
};

public static DeleteGrp = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);

  request.tenantid = tenantID;
  const url =`/Customer/DeleteVendorGroups`;
  return Instense.delete(url,{ params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};


public static GetProductJobMapping = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  // debugger;
  request.tenantid = tenantID;
  const url = `/Vendor/GetProductJobMapping`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};


public static GetUnits = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  
  request.tenantid = tenantID;
  const url = `/Vendor/GetUnits`;
  return Instense.get(url, { params: request }).then((response) => {
   
    let result = response.data.result as any;
    return result;
  });
};


}


